var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileImportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 15.9993V12.6072C5.33334 8.28053 5.33334 6.11706 6.51477 4.65186C6.75345 4.35586 7.02309 4.08613 7.31912 3.84746C8.78442 2.66599 10.9478 2.66599 15.2744 2.66599C16.2152 2.66599 16.6855 2.66599 17.1163 2.81799C17.2059 2.84973 17.2936 2.88599 17.3793 2.92706C17.7915 3.12413 18.124 3.45666 18.7892 4.12186L25.1045 10.4373C25.8753 11.208 26.2607 11.5935 26.4637 12.0835C26.6667 12.5735 26.6667 13.1185 26.6667 14.2085V18.666C26.6667 23.6944 26.6667 26.2085 25.1045 27.7706C23.6924 29.1828 21.502 29.3183 17.3793 29.3313M17.3333 3.33266V3.99933C17.3333 7.77066 17.3333 9.65626 18.5049 10.8279C19.6765 11.9993 21.5621 11.9993 25.3333 11.9993H26",
    stroke: "#1E252D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24.0006H5.33334M10.6667 29.334V18.6673",
    stroke: "#3D4AF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImportIcon);
export default __webpack_public_path__ + "static/media/file-import-icon.77c72fe6e7f5ab35c51f9fe5bf51c622.svg";
export { ForwardRef as ReactComponent };